<template>
  <!-- <div> <iframe :src="PDFData" frameborder="0" style="width: 100%; height: 100vh"></iframe></div> -->
  <div class='ukeyGuide'>
    <pdfPreview :url='PDFData'></pdfPreview>
  </div>
</template>

<script>
import PdfPreview from '@/components/pdfPreview.vue'
export default {
  components: { PdfPreview },
  data() {
    return {
      PDFData:
        'https://yhca-pro-public-download.oss-cn-hangzhou.aliyuncs.com/seal_assistant_operating_instruction.pdf'
    }
  },
  created() {}
}
</script>

<style>
body,
html {
  width: 100%;
  overflow-x: hidden;
  margin: 0;
  padding: 0;
}
.ukeyGuide {
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
}
</style>
